import { isServer } from "@tanstack/react-query"
import { z } from "zod"

import { defaultQueryOptions } from "@/lib/query-defaults"

/**
 * Retrieves the base URL for the application. This function is mainly used by React Query hooks (useSuspenseQuery) so we can do the first query on the server and the rest on the client.
 * If running on the server, it uses the value of the `NEXT_PUBLIC_FRONT_URL` environment variable.
 * If the value is not available or empty, it falls back to `http://localhost:3000`.
 * If running on the client, it returns an empty string.
 * @returns The base URL of the application.
 */
export function getBaseURL() {
  if (!isServer) {
    return ""
  }

  const frontURL = z.string().catch("").parse(process.env.NEXT_PUBLIC_FRONT_URL)
  const isLocalhost = frontURL.includes("localhost")

  if (frontURL) {
    return `http${isLocalhost ? "" : "s"}://${frontURL}`
  }

  // Fallback to localhost
  return "http://localhost:3000"
}

export function shouldEnableBrowserQuery(enabled: boolean) {
  return !isServer && enabled
}

export const baseQueryConfig = {
  ...defaultQueryOptions,
}
